import React, { Component } from "react";
import itone from "../../assets/walkin/ITOnelogo.png";
import scg from "../../assets/feednews/scg_logo.png";
import "./wk.style.css";

export default class footerlogo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="wk-footer-logos">
        <img src={scg} alt="SCG Logo" className="wk-company-logo" />
        <img src={itone} alt="IT One Logo" className="wk-company-logo" />
      </div>
    );
  }
}
